
window.OKENDO_DATA = [];

(function () {
  'use strict';

  var root = document.querySelector('[data-dlp-hero]');

  var CFG = {
  handles: {
    Standard: root ? root.dataset.handleStandard : '',
    Large: root ? root.dataset.handleLarge : '',
    'X-Large': root ? root.dataset.handleXlarge : ''
  },
  productTitle: root ? (root.dataset.productTitle || 'Product') : 'Product'
};

// ── SUBSCRIPTION DISCOUNT TARGETS ─────────────────────────────────
// The business rules this page sells against:
//
//   • First subscription order  → 30% off   (both packs)
//   • Every recurring order     → 15% off   (1 Pack  / "1 month" plan)
//                               → 20% off   (3 Packs / "3 month" plan)
//
// IMPORTANT: these numbers are TARGETS, used for exactly two things:
//   1. choosing which Shopify selling plan gets attached to the cart line, and
//   2. warning in the console when the plan configured in Shopify Admin does
//      not match what this page is advertising.
//
// They are NEVER used to compute a price that is shown to the customer. Every
// displayed price is read back out of Shopify's own selling_plan_allocation
// (see firstOrderPrice / renewalPrice below), so the page physically cannot
// advertise a number that checkout will refuse to honour.
//
// Overridable per-section from dlp-hero.liquid via data-discount-* attributes.
function dlpNum(v, dflt) {
  var n = parseFloat(v);
  return isNaN(n) ? dflt : n;
}

var DISCOUNTS = {
  first: dlpNum(root && root.dataset.discountFirst, 30),
  renew: {
    monthly1:  dlpNum(root && root.dataset.discountRenew1, 15),
    quarterly: dlpNum(root && root.dataset.discountRenew3, 20)
  }
};

// Kept only so existing markup/analytics that set data-repeat-customer keeps
// working. It NO LONGER selects a discount tier: "first order vs renewal" is a
// property of the subscription contract, not of the customer, and Shopify
// resolves it per billing cycle. See the note above renewalPrice().
var isRepeatCustomer = root ? root.dataset.repeatCustomer === 'true' : false;

var S = {
  // Start on the size the section is configured to default to, so the active
  // size tab and the prices on screen always describe the same product. (The
  // tab's `is-on` class is set server-side from the same setting.) Falls back
  // to Large whenever no Standard product is linked.
  size: (root && root.dataset.defaultSize === 'standard' && root.dataset.handleStandard)
    ? 'Standard'
    : 'Large',
  freq: 'monthly1',
  isSub: true,
  isRepeatCustomer: isRepeatCustomer,
  selectedPack: 1,
  variants: [],
  variantMap: {},
  allocMap: {},
  productId: null,
  productIds: {},
  reviewPage: 1,
   ready: false
};

  // Gallery state is module-scoped on purpose: initGallery() is re-entrant
  // (see the note on it below) and every re-run must share one slide index,
  // one timer and one handler rather than creating a fresh set.
  var galInit = false;
  var galTimer = null;      // the single auto-advance interval
  var galResume = null;     // timeout that restarts it after manual use
  var galCur = 0;           // current slide index
  var galGo = null;         // latest navigation fn, rebuilt per init
  var galArrowsBound = false;

  var GAL_AUTO_MS = 5000;   // gap between automatic advances
  var GAL_PAUSE_MS = 10000; // quiet period after the visitor clicks an arrow/dot

  // Auto-advance is driven through these two helpers only, so there is exactly
  // one interval and one pending restart at any moment no matter how many times
  // initGallery() re-runs or how fast the visitor clicks.
  function galStopAuto() {
    if (galTimer) { clearInterval(galTimer); galTimer = null; }
    if (galResume) { clearTimeout(galResume); galResume = null; }
  }

  function galStartAuto(delay) {
    galStopAuto();
    galResume = setTimeout(function () {
      galResume = null;
      galTimer = setInterval(function () { if (galGo) galGo(galCur + 1); }, GAL_AUTO_MS);
    }, typeof delay === 'number' ? delay : GAL_AUTO_MS);
  }

  // Every manual navigation goes through here: move one step, then hold the
  // timer off for GAL_PAUSE_MS. Without this the visitor's click and a timer
  // tick could land together and the gallery would appear to skip 2-3 images.
  function galManual(n) {
    if (!galGo) return;
    galGo(n);
    galStartAuto(GAL_PAUSE_MS);
  }

  function fmt(cents) { return '$' + (cents / 100).toFixed(2); }

  function toast(msg) {
    var t = document.getElementById('bp-toast');
    if (!t) { console.warn('[BarkPotty]', msg); return; }
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(t._to);
    t._to = setTimeout(function () { t.classList.remove('show'); }, 3500);
  }

  function escHtml(s) {
    return String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  // ── SELLING PLAN HELPER ───────────────────────────────────────
  function getBestAllocation(variant) {
  var allocs = variant && variant.selling_plan_allocations || [];
  if (!allocs.length) return null;
  return allocs.reduce(function (best, a) {
    return (!best || a.price < best.price) ? a : best;
  }, null);
}

// NEW — add this right below getBestAllocation
function getAllocationForPlan(variant, planId) {
  if (!planId) return null;
  var allocs = variant && variant.selling_plan_allocations || [];
  for (var i = 0; i < allocs.length; i++) {
    if (String(allocs[i].selling_plan_id) === String(planId)) {
      return allocs[i];
    }
  }
  return null;
}

  // ── TIERED SUBSCRIPTION PRICING ───────────────────────────────
  // A Shopify selling plan can carry up to two price adjustments:
  //
  //   position 1, order_count: 1     → applies to the FIRST order only
  //   position 2, order_count: null  → applies to EVERY order after that, for
  //                                    the whole life of the subscription
  //
  // That second adjustment is what makes the recurring discount PERSIST across
  // renewals. It is copied onto the subscription contract at checkout, so every
  // future billing cycle re-applies it automatically — nothing has to run on
  // our side at renewal time, and the customer keeps the rate they signed up on.
  //
  // Shopify resolves both adjustments into concrete prices on the allocation:
  //
  //   allocation.price_adjustments[0].price → charged on order #1   (30% off)
  //   allocation.price_adjustments[1].price → charged on every renewal
  //                                           (15% off 1 Pack, 20% off 3 Pack)
  //
  // We read those two numbers straight out of Shopify and never do the discount
  // arithmetic ourselves, so what the page shows and what the customer is
  // actually charged cannot drift apart.

  // What the customer pays on the very first order of the subscription.
  function firstOrderPrice(alloc, regPrice) {
    if (!alloc) return regPrice;
    var pa = alloc.price_adjustments || [];
    if (pa.length && typeof pa[0].price === 'number') return pa[0].price;
    // No adjustments exposed → alloc.price is already the first-order price.
    return typeof alloc.price === 'number' ? alloc.price : regPrice;
  }

  // What the customer pays on EVERY order after the first.
  function renewalPrice(alloc, plan, regPrice) {
    if (!alloc) return regPrice;
    var pa = alloc.price_adjustments || [];
    var defs = (plan && plan.price_adjustments) || [];

    // Two adjustments → the last one is the uncapped recurring tier.
    if (pa.length > 1 && typeof pa[pa.length - 1].price === 'number') {
      return pa[pa.length - 1].price;
    }
    // One adjustment → it only recurs forever if it has no order_count cap.
    // A capped single adjustment expires after order #1 and renewals go back
    // to the regular price.
    if (pa.length === 1 && typeof pa[0].price === 'number') {
      return (defs.length && defs[0].order_count) ? regPrice : pa[0].price;
    }
    // No adjustments at all → the plan bills at the regular price.
    return typeof alloc.price === 'number' ? alloc.price : regPrice;
  }

  // Percentage off, derived from two real prices (never from a hardcoded rule).
  function pctOff(regPrice, price) {
    if (!regPrice || typeof price !== 'number') return 0;
    return Math.round((1 - price / regPrice) * 100);
  }
 

  // Reduce a selling plan's raw adjustment list to {first, renew} percentages.
  // Used to pick the right plan and to sanity-check the Admin configuration.
  function planProfile(sp) {
    var adjs = (sp && sp.price_adjustments) || [];
    var prof = { first: 0, renew: 0 };
    adjs.forEach(function (a) {
      var pct = a.value_type === 'percentage' ? (a.value || 0) : 0;
      if (a.order_count) prof.first = pct;   // capped run  → first order only
      else prof.renew = pct;                 // uncapped    → every renewal
    });
    // A lone uncapped adjustment covers the first order as well as renewals.
    if (adjs.length === 1 && !adjs[0].order_count) prof.first = prof.renew;
    return prof;
  }

  // ── SERVER-RENDERED SEED ────────────────────────
  // dlp-hero.liquid ships BOTH products' JSON (identical in shape to
  // /products/<handle>.js, because it is produced by Liquid's `| json` filter)
  // inside <script type="application/json" data-dlp-pricing-data>.
  //
  // Hydrating from that seed means correct subscription prices are painted on
  // first render and size switching is instant - no empty price slots, no
  // waiting on the network. fetchProduct() still runs immediately afterwards
  // and overwrites the seed with live data, so price/stock edits made in Admin
  // are always picked up. If the seed tag is absent, the page behaves exactly
  // as it did before this change.
  var SEED = (function () {
    var el = document.querySelector('[data-dlp-pricing-data]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent || 'null');
    } catch (e) {
      console.warn('[BarkPotty] Could not parse seeded pricing data:', e);
      return null;
    }
  })();

  
  // ── PRODUCT DATA ──────────────────────────────
  // Single code path used by BOTH the seed and the network response, so the
  // two can never disagree about variants, plans or prices.
  function applyProductData(jsData) {
    if (!jsData || !jsData.variants || !jsData.variants.length) return false;

    S.productId = jsData.id || null;
    S.productIds[S.size] = S.productId;
    S.variants = jsData.variants || [];

    var plans = [];
    (jsData.selling_plan_groups || []).forEach(function (g) {
      (g.selling_plans || []).forEach(function (sp) { plans.push(sp); });
    });
    S.plans = plans;

    // Normalise allocations: Liquid's `| json` can nest the plan object while
    // the AJAX API exposes a flat selling_plan_id. Give the rest of this file
    // exactly one shape to deal with.
    S.variants.forEach(function (v) {
      (v.selling_plan_allocations || []).forEach(function (a) {
        if (a.selling_plan_id == null && a.selling_plan && a.selling_plan.id != null) {
          a.selling_plan_id = a.selling_plan.id;
        }
      });
    });

    S.variantMap = {};
    S.variants.forEach(function (v) {
      var o1 = (v.option1 || '').trim().toLowerCase();
      if (o1 === '1 pack') S.variantMap['monthly1'] = v;
      if (o1 === '3 packs') {
        S.variantMap['quarterly'] = v;
        S.variantMap['onetime'] = v;
      }
    });

    // ── SELLING PLAN SELECTION ──────────────────────
    // For each frequency card, pick the selling plan whose ACTUAL price
    // adjustments best match the rules in DISCOUNTS: 30% on the first order,
    // then 15% (1 Pack) / 20% (3 Pack) on every order after.
    //
    // The previous build matched on the plan NAME containing "15%"/"20%" and
    // silently fell back to the 30%-forever plan when no such name existed -
    // and no such plan exists on this store, so the recurring tier never
    // engaged. Scoring the real adjustment values instead means the correct
    // plan is picked whether the merchant edits the existing plans or creates
    // new ones, and renaming a plan can never break it.
    function pickPlan(nameNeedle, targetRenew) {
      var named = S.plans.filter(function (sp) {
        return String(sp.name || '').toLowerCase().indexOf(nameNeedle) !== -1;
      });
      // If plan names ever drift, score every plan rather than giving up.
      var pool = named.length ? named : S.plans;

      var best = null, bestScore = Infinity;
      pool.forEach(function (sp) {
        var p = planProfile(sp);
        var score = Math.abs(p.first - DISCOUNTS.first) +
                    Math.abs(p.renew - targetRenew);
        if (score < bestScore) { bestScore = score; best = sp; }
      });

      // Loud, actionable warning when Admin config != what the page advertises.
      if (best) {
        var prof = planProfile(best);
        if (prof.first !== DISCOUNTS.first || prof.renew !== targetRenew) {
          console.warn(
            '[BarkPotty] Selling plan "' + best.name + '" is configured as ' +
            prof.first + '% first order / ' + prof.renew + '% recurring, but this ' +
            'page sells ' + DISCOUNTS.first + '% / ' + targetRenew + '%. Fix it in ' +
            'Shopify Admin - see README, "Shopify Admin configuration". The page ' +
            'is showing the real Shopify prices, not the intended ones.'
          );
        }
      }
      return best;
    }

    S.planMap = {
      monthly1:  pickPlan('1 month', DISCOUNTS.renew.monthly1),
      quarterly: pickPlan('3 month', DISCOUNTS.renew.quarterly)
    };

    // Match the exact plan's allocation first; fall back to the cheapest
    // allocation so add-to-cart never breaks if plan matching came up empty.
    S.allocMap = {
      monthly1: getAllocationForPlan(S.variantMap.monthly1, S.planMap.monthly1 && S.planMap.monthly1.id)
                 || getBestAllocation(S.variantMap.monthly1),
      quarterly: getAllocationForPlan(S.variantMap.quarterly, S.planMap.quarterly && S.planMap.quarterly.id)
                 || getBestAllocation(S.variantMap.quarterly)
    };

    return true;
  }

  // Paint prices immediately from the seed. Deliberately does NOT rebuild the
  // gallery - the gallery is already server-rendered by dlp-hero.liquid and
  // rebuilding it here would cause a visible flicker.
  function hydrateFromSeed() {
    if (!SEED) return false;
    if (!applyProductData(SEED[S.size])) return false;

    // Only trust the seed if it actually carried selling-plan allocation
    // pricing. dlp-hero.liquid already rendered the correct prices into the
    // markup server-side; repainting them from an allocation-less seed would
    // replace correct discounted prices with undiscounted ones. Bailing out
    // here leaves the server-rendered prices on screen until the fetch lands.
    if (!S.allocMap.monthly1 && !S.allocMap.quarterly) return false;

    updatePrices();
    return true;
  }

  function fetchProduct() {
    var handle = CFG.handles[S.size] || CFG.handles['Large'];
    var requestedSize = S.size;      // snapshot which size this call is for
    var btn = document.querySelector('[data-dlp-atc]');

    // Seed first, so prices are correct instantly. Only hold add-to-cart back
    // if we genuinely have nothing to go on yet.
    var seeded = hydrateFromSeed();
    S.ready = seeded;
    if (btn) {
      btn.disabled = !seeded;
      if (seeded) delete btn.dataset.loading;
      else btn.dataset.loading = '1';
    }

    Promise.all([
      fetch('/products/' + handle + '.json').then(function (r) { return r.json(); }),
      fetch('/products/' + handle + '.js').then(function (r) { return r.json(); })
    ])
      .then(function (results) {
        // If the user switched size again before this resolved, drop the stale
        // response instead of overwriting the newer size's prices.
        if (requestedSize !== S.size) return;

        applyProductData(results[1]);   // live data wins over the seed

        var jsonData = results[0] && results[0].product;
        if (jsonData && jsonData.images && jsonData.images.length) {
          updateGallery(jsonData.images);
        }

        updatePrices();

        S.ready = true;
        if (btn) { btn.disabled = false; delete btn.dataset.loading; }
      })
      .catch(function (err) {
        console.error('[BarkPotty] fetchProduct error:', err);
        if (requestedSize === S.size && btn) { btn.disabled = false; delete btn.dataset.loading; }
      });
  }

  // function getRegPrice(freq) {
  //   var v = S.variantMap[freq];
  //   return v ? parseInt(v.price || 0) : 0;
  // }

  // function getDiscountedPrice(freq) {
  //   var v = S.variantMap[freq];
  //   var plan = S.planMap[freq];
  //   if (!v) return 0;

  //   var basePrice = parseInt(v.price || 0);
  //   if (freq === 'onetime' || !plan) return basePrice;

  //   var adj = (plan.price_adjustments || [])[0];
  //   if (!adj) return basePrice;

  //   if (adj.value_type === 'percentage') return Math.round(basePrice * (1 - adj.value / 100));
  //   if (adj.value_type === 'fixed_amount') return Math.max(0, basePrice - adj.value);
  //   if (adj.value_type === 'price') return adj.value;
  //   return basePrice;
  // }

  // function getDiscountPct(freq) {
  //   var plan = S.planMap[freq];
  //   if (!plan) return 0;
  //   var adj = (plan.price_adjustments || [])[0];
  //   if (!adj) return 0;
  //   if (adj.value_type === 'percentage') return adj.value;
  //   var reg = getRegPrice(freq);
  //   var now = getDiscountedPrice(freq);
  //   return reg ? Math.round((1 - now / reg) * 100) : 0;
  // }

  // Undiscounted per-unit price, straight off the variant.
  function getRegPrice(freq) {
  var v = S.variantMap[freq];
  return v ? parseInt(v.price || 0) : 0;
}

// FIRST ORDER price (30% off). Name kept unchanged for backward compatibility
// with any other code on the page that already calls it.
function getDiscountedPrice(freq) {
  return firstOrderPrice(S.allocMap[freq], getRegPrice(freq));
}

// RECURRING price - what Shopify charges on every renewal after the first
// (15% off on the 1 Pack plan, 20% off on the 3 Pack plan).
function getRenewalPrice(freq) {
  return renewalPrice(S.allocMap[freq], S.planMap && S.planMap[freq], getRegPrice(freq));
}

function getDiscountPct(freq) {
  return pctOff(getRegPrice(freq), getDiscountedPrice(freq));
}

function getRenewalPct(freq) {
  return pctOff(getRegPrice(freq), getRenewalPrice(freq));
}

  function getPlan(freq) {
    return S.planMap[freq] || null;
  }

  function getVariant() {
    if (S.freq === 'onetime') {
      return S.selectedPack === 1 ? S.variantMap.monthly1 : S.variantMap.quarterly;
    }
    return S.variantMap[S.freq] || null;
  }

  // ── PRICE / UI UPDATES (dlp- prefixed to match dlp-hero.liquid) ──
  function updatePrices() {
    var c1 = document.querySelector('.dlp-freq-card[data-freq="monthly1"]');
    if (c1) {
      var reg1 = getRegPrice('monthly1');
      var now1 = getDiscountedPrice('monthly1');
      var disc1 = getDiscountPct('monthly1');
      var g1 = function (f) { return c1.querySelector('[data-f="' + f + '"]'); };
      if (g1('orig1')) g1('orig1').textContent = fmt(reg1);
      if (g1('now1')) g1('now1').textContent = fmt(now1);
      if (g1('save1')) g1('save1').textContent = 'Save ' + disc1 + '%';
      // RECURRING LINE (1 Pack). Previously this printed the full price,
      // which is now wrong: renewals carry their own standing discount (15%).
      // renew1 is Shopify's resolved price for every order after the first.
      var renew1 = getRenewalPrice('monthly1');
      var renewPct1 = getRenewalPct('monthly1');
      if (g1('renews1')) g1('renews1').innerHTML =
        'Renews at <span class="dlp-renew-price">' + fmt(renew1) + '</span> per unit (' +
        fmt(renew1) + ')' +
        (renewPct1 > 0 ? ' \u2014 save ' + renewPct1 + '% on every order' : '') +
        '. Cancel anytime.';
      c1.querySelectorAll('.dlp-product-title').forEach(function (t) {
        t.textContent = '1 ' + S.size + ' ' + CFG.productTitle;
      });
    }

    var c3 = document.querySelector('.dlp-freq-card[data-freq="quarterly"]');
    if (c3) {
      var reg3 = getRegPrice('quarterly');
      var now3 = getDiscountedPrice('quarterly');
      var disc3 = getDiscountPct('quarterly');
      var g3 = function (f) { return c3.querySelector('[data-f="' + f + '"]'); };
      if (g3('orig3')) g3('orig3').textContent = fmt(reg3);
      if (g3('now3')) g3('now3').textContent = fmt(now3);
      if (g3('unit3')) g3('unit3').textContent = 'Total: ' + fmt(now3 * 3);
      if (g3('save3')) g3('save3').textContent = 'Save ' + disc3 + '%';
      // RECURRING LINE (3 Pack). Same idea as above, but this plan ships 3
      // units per delivery, so the bracketed figure is the per-delivery total.
      var renew3 = getRenewalPrice('quarterly');
      var renewPct3 = getRenewalPct('quarterly');
      if (g3('renews3')) g3('renews3').innerHTML =
        'Renews at <span class="dlp-renew-price">' + fmt(renew3) + '</span> per unit (' +
        fmt(renew3 * 3) + ')' +
        (renewPct3 > 0 ? ' \u2014 save ' + renewPct3 + '% on every order' : '') +
        '. Cancel anytime.';
      c3.querySelectorAll('.dlp-product-title').forEach(function (t) {
        t.textContent = '3 ' + S.size + ' ' + CFG.productTitle;
      });
    }

    var ot = document.querySelector('[data-dlp-onetime]');
    if (ot) {
      var sourceFreq = S.selectedPack === 1 ? 'monthly1' : 'quarterly';
      var qty = sourceFreq === 'monthly1' ? 1 : 3;
      var regOT = getRegPrice(sourceFreq);
      var otUnit = ot.querySelector('[data-f="ot-price"]');
      var otTotal = ot.querySelector('[data-f="ot-total"]');
      var otSub = ot.querySelector('.dlp-ot-sub');
      if (otUnit) otUnit.textContent = fmt(regOT);
      if (otTotal) otTotal.textContent = 'Total: ' + fmt(regOT * qty);
      if (otSub) otSub.textContent = qty + ' ' + S.size + ' ' + CFG.productTitle;
    }

    updateDiscountBadges();
  }

  // The promo banner advertises the FIRST-ORDER discount ("30% Off Your First
  // Subscription Order"), so it must read the first-order tier specifically -
  // never the recurring tier, which is lower.
  function updateDiscountBadges() {
    var disc = getDiscountPct('monthly1') || getDiscountPct('quarterly') || 0;
    if (!disc) return;
    var promo = document.querySelector('[data-dlp-promo-highlight]');
    if (promo) promo.textContent = disc + '% Off';
  }

  // ── CART CLEAR (kept — needs S.productId, works regardless of markup) ──
  function clearBarkPottyFromCart(productId, callback) {   // CHANGED: added productId param
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var bpItems = (cart.items || []).filter(function (item) {
        return String(item.product_id) === String(productId);   // CHANGED: use param, not S.productId
      });
      if (!bpItems.length) { callback(); return Promise.resolve(); }
      return bpItems.reduce(function (chain, item) {
        return chain.then(function () {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: item.key, quantity: 0 })
          });
        });
      }, Promise.resolve()).then(callback);
    })
    .catch(function (err) {
      console.warn('[BarkPotty] clearBarkPottyFromCart error:', err);
      callback();
    });
}

  // ── GALLERY (dlp- prefixed) ──
  function updateGallery(images) {
    if (!images || !images.length) return;
    var track = document.querySelector('[data-dlp-gal-track]');
    var dots = document.querySelector('[data-dlp-gal-dots]');
    if (!track) return;
    track.innerHTML = '';
    if (dots) dots.innerHTML = '';
    images.slice(0, 6).forEach(function (img, i) {
      var slide = document.createElement('div');
      slide.className = 'dlp-gal-slide';
      var im = document.createElement('img');
      var imgSrc = typeof img === 'string' ? img : (img.src || img.url || '');
      var imgAlt = (typeof img === 'object' && img.alt) ? img.alt : (CFG.productTitle + ' ' + (i + 1));
      if (imgSrc && imgSrc.indexOf('//') === 0) imgSrc = 'https:' + imgSrc;
      im.src = imgSrc; im.alt = imgAlt; im.loading = i === 0 ? 'eager' : 'lazy';
      slide.appendChild(im); track.appendChild(slide);
      if (dots) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'dlp-gal-dot' + (i === 0 ? ' is-on' : '');
        dot.dataset.i = i;
        dot.setAttribute('aria-label', 'Slide ' + (i + 1));
        dots.appendChild(dot);
      }
    });
    galInit = false; initGallery();
  }

  // Re-entrant by design: updateGallery() clears galInit and calls this again on
  // every product fetch - page load, and each size tab click. Previously each run
  // added ANOTHER click listener to the arrows and started ANOTHER setInterval,
  // and never removed the old ones. After a couple of size switches the arrows
  // fired several stale closures at once (each with its own `cur`, so they
  // cancelled out and the arrow looked dead) while the slider auto-advanced once
  // per accumulated timer. Fixed by: binding the arrows exactly once, replacing
  // the timer instead of stacking it, and keeping the index in module scope.
  function initGallery() {
    if (galInit) return; galInit = true;
    var track = document.querySelector('[data-dlp-gal-track]'); if (!track) return;
    galCur = 0;
    function slideCount() { return track.children.length || 1; }

    galGo = function (n) {
      var total = slideCount();
      galCur = ((n % total) + total) % total;
      track.style.transform = 'translateX(-' + (galCur * 100) + '%)';
      document.querySelectorAll('.dlp-gal-dot').forEach(function (d, i) { d.classList.toggle('is-on', i === galCur); });
    };

    // Arrows live outside the track, so they survive updateGallery() wiping it.
    // Bind them once; they always call through to the current galGo.
    if (!galArrowsBound) {
      galArrowsBound = true;
      var gp = document.querySelector('[data-dlp-gal-prev]');
      var gn = document.querySelector('[data-dlp-gal-next]');
      if (gp) gp.addEventListener('click', function () { galManual(galCur - 1); });
      if (gn) gn.addEventListener('click', function () { galManual(galCur + 1); });
    }

    // Dots ARE recreated by updateGallery(), so these bind fresh each time
    // without accumulating on the old (discarded) elements.
    document.querySelectorAll('.dlp-gal-dot').forEach(function (d) {
      d.addEventListener('click', function () { galManual(+d.dataset.i); });
    });

    galStartAuto(GAL_AUTO_MS);
  }

  // ── SIZE TABS (dlp- prefixed) ──
  function bindSizes() {
    document.querySelectorAll('.dlp-size-tab').forEach(function (b) {
      b.addEventListener('click', function () {
        document.querySelectorAll('.dlp-size-tab').forEach(function (x) { x.classList.remove('is-on'); });
        b.classList.add('is-on');
        S.size = b.dataset.dlpSize;
        galInit = false;
        fetchProduct();
      });
    });
  }

  // ── SIZE FROM URL (?size=Standard|Large|XL) ──
  // Used by legacy Bark Potty redirects. Clicks the real tab so bindSizes()
  // does the work (active state, S.size, gallery, prices, ATC). Returns true
  // if a tab was clicked, since that already kicked off fetchProduct().
  function selectSizeFromUrl() {
    var raw;
    try { raw = new URLSearchParams(window.location.search).get('size'); } catch (e) { return false; }
    if (!raw) return false;
    var map = { standard: 'Standard', large: 'Large', xl: 'X-Large', 'x-large': 'X-Large', xlarge: 'X-Large' };
    var size = map[raw.trim().toLowerCase()];
    if (!size || size === S.size) return false;
    var tab = document.querySelector('.dlp-size-tabs [data-dlp-size="' + size + '"]');
    if (!tab) return false;
    tab.click();
    return true;
  }

  // ── FREQUENCY CARDS + ONE-TIME (dlp- prefixed) ──
  function initFreq() {
    var cards = document.querySelectorAll('.dlp-freq-card[data-freq]');
    var ot = document.querySelector('[data-dlp-onetime]');

    function clearAll() {
      cards.forEach(function (x) { x.classList.remove('is-on'); });
      if (ot) ot.classList.remove('is-on');
    }

    cards.forEach(function (c) {
      c.addEventListener('click', function () {
        clearAll();
        c.classList.add('is-on');
        S.freq = c.dataset.freq;
        S.selectedPack = parseInt(c.dataset.qty) || 1;
        S.isSub = true;
        updatePrices();
      });
    });

    if (ot) {
      ot.addEventListener('click', function () {
        clearAll();
        ot.classList.add('is-on');
        S.freq = 'onetime';
        S.isSub = false;
        S.selectedPack = S.selectedPack || 3;
        updatePrices();
      });
    }

    var def = document.querySelector('.dlp-freq-card.is-on[data-freq]');
    S.selectedPack = def ? (parseInt(def.dataset.qty) || 1) : 1;
    S.freq = def ? def.dataset.freq : 'monthly1';
  }

  // ── ADD TO CART (dlp- prefixed) ──
  function initAtc() {
  var btn = document.querySelector('[data-dlp-atc]');
  if (!btn) return;
  btn.addEventListener('click', function () {
    if (!S.ready) {                       // NEW
      toast('Still loading — please wait a moment and try again.');
      return;
    }

    var v = getVariant();
    if (!v) {
      toast('Could not find variant for ' + S.size + ' / ' + S.freq + '. Please refresh.');
      return;
    }
    btn.disabled = true;
    var label = btn.textContent;
    btn.textContent = 'Adding…';

    var qty = S.freq === 'onetime'
      ? (S.selectedPack || 3)
      : ({ monthly1: 1, quarterly: 3 }[S.freq] || 1);

    var item = { id: v.id, quantity: qty };
      item.properties = item.properties || {};
      item.properties['_bp_qty_step'] = String(qty);

      if (S.isSub) {
        // Attaching selling_plan is what makes this a subscription line. Shopify
        // then prices the line from the plan's allocation - 30% off for this
        // first order - and stores the plan on the resulting subscription
        // contract, so the recurring tier (15% / 20%) is applied automatically
        // on every renewal without any further work from us.
        var alloc = S.allocMap[S.freq];
        if (!alloc) {
          toast('Subscription plan not found. Please refresh.');
          btn.disabled = false; btn.textContent = label; return;
        }
        item.selling_plan = alloc.selling_plan_id;

        // Hidden line item properties (underscore prefix = not shown to the
        // customer). They record on the order what was advertised at
        // add-to-cart time, which makes support and refund questions
        // answerable months later.
        item.properties['_bp_first_order_discount'] = getDiscountPct(S.freq) + '%';
        item.properties['_bp_recurring_discount'] = getRenewalPct(S.freq) + '%';
      }

    var productIdForThisAdd = S.productId;   // NEW: snapshot right before clearing/adding

    clearBarkPottyFromCart(productIdForThisAdd, function () {   // NEW: pass it explicitly
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [item] })
      })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (d.status && d.status >= 400) { toast(d.description || 'Could not add to cart.'); }
          else {
            if (window.DLP && typeof window.DLP.openCart === 'function') {
              window.DLP.openCart();
            } else {
              document.dispatchEvent(new CustomEvent('cart:refresh'));
            }
          }
        })
        .catch(function () { toast('Error — please try again.'); })
        .finally(function () { btn.disabled = false; btn.textContent = label; });
    });
  });
}

  // ── REFUND BOX MOBILE READ MORE/LESS (dlp- prefixed, confirmed in dlp-hero.liquid) ──
  function initRefundToggle() {
    var CHAR_LIMIT = 194;
    document.querySelectorAll('.dlp-refund-box--mobile .dlp-refund-text').forEach(function (p) {
      var fullText = p.textContent.trim();
      if (fullText.length <= CHAR_LIMIT) return;
      var shortText = fullText.slice(0, CHAR_LIMIT).trimEnd() + '...';
      var expanded = false;
      function render() {
        p.innerHTML = (expanded ? fullText : shortText) +
          ' <a class="dlp-refund-toggle" href="#">' + (expanded ? 'Read Less' : 'Read More') + '</a>';
        p.querySelector('.dlp-refund-toggle').addEventListener('click', function (e) {
          e.preventDefault(); expanded = !expanded; render();
        });
      }
      render();
    });
  }

  // ── TESTIMONIAL CAROUSEL (dlp- prefixed, confirmed against real markup) ──
  function initTestiCarousel() {
    var track = document.querySelector('[data-dlp-testi-track]');
    if (!track) return;
    var cards = Array.prototype.slice.call(track.querySelectorAll('.dlp-testi-card'));
    var total = cards.length;
    if (!total) return;
    var current = 0;
    var autoTimer = null;

    function isMobile() { return window.innerWidth <= 768; }

    function getCardWidth() {
      if (!cards[0]) return 0;
      var s = window.getComputedStyle(track);
      var gap = parseFloat(s.columnGap || s.gap || 24) || 24;
      return cards[0].getBoundingClientRect().width + gap;
    }

    function goTo(index, animate) {
      if (!isMobile()) {
        track.style.transition = 'none';
        track.style.transform = 'translateX(0)';
        return;
      }
      current = ((index % total) + total) % total;
      track.style.transition = animate === false ? 'none' : 'transform 0.5s ease';
      track.style.transform = 'translateX(-' + (current * getCardWidth()) + 'px)';
      updateDots();
    }

    function updateDots() {
      document.querySelectorAll('.dlp-testi-dot').forEach(function (d, i) {
        d.classList.toggle('is-on', i === current);
      });
    }

    function startAuto() {
      stopAuto();
      if (!isMobile()) return;
      autoTimer = setInterval(function () { goTo(current + 1, true); }, 3500);
    }
    function stopAuto() { clearInterval(autoTimer); }

    var tsX = 0;
    track.addEventListener('touchstart', function (e) { tsX = e.touches[0].clientX; stopAuto(); }, { passive: true });
    track.addEventListener('touchend', function (e) {
      var d = tsX - e.changedTouches[0].clientX;
      if (Math.abs(d) > 40) goTo(d > 0 ? current + 1 : current - 1, true);
      startAuto();
    }, { passive: true });

    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () { goTo(current, false); startAuto(); }, 200);
    });

    goTo(0, false);
    startAuto();
  }

  document.addEventListener('DOMContentLoaded', initTestiCarousel);
  if (document.readyState !== 'loading') initTestiCarousel();

  // ── FAQ ACCORDION ──────────────────────────────────────────────
function initAccordion() {
  var items = document.querySelectorAll('#bp-acc .dlp-acc-item');

  if (!items.length) return;

  function closeItem(item) {
    item.classList.remove('is-open');

    var btn = item.querySelector('.dlp-acc-trig');
    var icon = item.querySelector('.dlp-acc-ico span');

    if (btn) btn.setAttribute('aria-expanded', 'false');
    if (icon) icon.textContent = '+';
  }

  function openItem(item) {
    item.classList.add('is-open');

    var btn = item.querySelector('.dlp-acc-trig');
    var icon = item.querySelector('.dlp-acc-ico span');

    if (btn) btn.setAttribute('aria-expanded', 'true');
    if (icon) icon.textContent = '−';
  }

  // First FAQ always open
  items.forEach(closeItem);
  openItem(items[0]);

  items.forEach(function (item) {
    var trigger = item.querySelector('.dlp-acc-trig');

    if (!trigger) return;

    trigger.addEventListener('click', function () {

      // Already open → do nothing (keeps one item always open)
      if (item.classList.contains('is-open')) return;

      // Close all
      items.forEach(closeItem);

      // Open clicked item
      openItem(item);
    });
  });
}

document.addEventListener('DOMContentLoaded', initAccordion);
  if (document.readyState !== 'loading') initAccordion();

  // ── FAQ ACCORDION ──────────────────────────────────────────────
function initFaqAccordion() {
  var items = document.querySelectorAll('.dlp-faq-item');

  if (!items.length) return;

  function closeItem(item) {
    item.classList.remove('is-open');

    var btn = item.querySelector('.dlp-faq-trig');
    var icon = item.querySelector('.dlp-faq-ico span');

    if (btn) btn.setAttribute('aria-expanded', 'false');
    if (icon) icon.textContent = '+';
  }

  function openItem(item) {
    item.classList.add('is-open');

    var btn = item.querySelector('.dlp-faq-trig');
    var icon = item.querySelector('.dlp-faq-ico span');

    if (btn) btn.setAttribute('aria-expanded', 'true');
    if (icon) icon.textContent = '−';
  }

  // First FAQ always open
  items.forEach(closeItem);
  openItem(items[0]);

  items.forEach(function (item) {
    var trigger = item.querySelector('.dlp-faq-trig');

    if (!trigger) return;

    trigger.addEventListener('click', function () {

      // Already open → do nothing
      if (item.classList.contains('is-open')) return;

      // Close all FAQs
      items.forEach(closeItem);

      // Open clicked FAQ
      openItem(item);
    });
  });
}

document.addEventListener('DOMContentLoaded', initFaqAccordion);
  if (document.readyState !== 'loading') initFaqAccordion();

  // ── HERO INIT — only what's confirmed to exist in dlp-hero.liquid ──
  function initHero() {
    initGallery();
    bindSizes();
    initFreq();
    initAtc();
    initRefundToggle();
    if (!selectSizeFromUrl()) fetchProduct();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHero);
  } else {
    initHero();
  }

})();

/* ─────────────────────────────────────────────────────────────
   EVERYTHING BELOW THIS LINE targets sections whose real markup
   I have not been shown yet: #bpld .nav, .how-grid, .bpld-timeline,
   .testi-track, .feat-carousel-track, #bp-cart-drawer, #bp-mob/#bp-ham nav,
   #bp-acc / .faq-trig, Okendo reviews grid.

   These functions are LEFT AS-IS (unchanged from your original file) so
   nothing here is guessed or broken further. If any of these features
   aren't working on your live page, share that section's actual HTML/liquid
   and I will correct the selectors the same way I did for the hero above.

   ── TWO EXCEPTIONS — confirmed against your real dlp-hero.liquid ──
   In the big Okendo review script further down (updateSitewideCount and
   waitForFirstLoad), replace these two lines wherever they appear:

     const heroCountLink = document.querySelector('.bpld-ratings__reviews a');
   → const heroCountLink = document.querySelector('[data-dlp-review-count]');

     const heroScore = document.querySelector('.bpld-ratings__score');
   → const heroScore = document.querySelector('[data-dlp-rating-score]');

   These two elements DO exist in dlp-hero.liquid (as data-dlp-review-count
   and data-dlp-rating-score), so these two swaps are safe to make right now
   without needing to see any other section's markup.
   ───────────────────────────────────────────────────────────── */


 // ── FEATURE CAROUSEL (native scroll-snap, no dots) ─────────────
function initFeatureCarousel() {

  // support multiple instances of the section on one page
  var tracks = document.querySelectorAll('[data-dlp-feature-track]');
  if (!tracks.length) return;

  tracks.forEach(function (track) {

    var cards = Array.prototype.slice.call(track.querySelectorAll('.dlp-feat-item'));
    var total = cards.length;
    if (!total) return;

    var current = 0;
    var autoTimer = null;

    function isMobile() {
      return window.innerWidth <= 768;
    }

    // find which card is currently centered/leading in the scroll container
    function syncCurrentFromScroll() {
      var trackLeft = track.scrollLeft;
      var closest = 0;
      var closestDist = Infinity;
      cards.forEach(function (card, i) {
        var dist = Math.abs(card.offsetLeft - trackLeft);
        if (dist < closestDist) {
          closestDist = dist;
          closest = i;
        }
      });
      current = closest;
    }

    function goTo(index) {
      if (!isMobile()) return;
      current = ((index % total) + total) % total;
      track.scrollTo({
        left: cards[current].offsetLeft,
        behavior: 'smooth'
      });
    }

    function next() {
      goTo(current + 1);
    }

    function startAuto() {
      stopAuto();
      if (!isMobile() || total < 2) return;
      autoTimer = setInterval(next, 3500);
    }

    function stopAuto() {
      clearInterval(autoTimer);
    }

    // pause autoplay while the user is actively interacting
    track.addEventListener('touchstart', stopAuto, { passive: true });
    track.addEventListener('touchend', function () {
      // let native momentum scroll settle, then resync + resume
      setTimeout(function () {
        syncCurrentFromScroll();
        startAuto();
      }, 300);
    }, { passive: true });

    // keep `current` accurate if the user scrolls manually (no snap event needed)
    var scrollDebounce;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollDebounce);
      scrollDebounce = setTimeout(syncCurrentFromScroll, 150);
    }, { passive: true });

    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () {
        if (!isMobile()) {
          stopAuto();
          return;
        }
        syncCurrentFromScroll();
        startAuto();
      }, 200);
    });

    startAuto();
  });
}

document.addEventListener('DOMContentLoaded', initFeatureCarousel);
if (document.readyState !== 'loading') {
  initFeatureCarousel();
}